import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from "@headlessui/react";
import { Fragment } from "react";
export default function MobileWrapperDialog(t0) {
  const $ = _c(31);
  const {
    title,
    isOpen,
    onClose,
    onBeforeLeave,
    onAfterLeave,
    children,
    noPadding
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px]" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onAfterLeave || $[2] !== onBeforeLeave) {
    t2 = <TransitionChild as={Fragment} enter="tw-ease-in-out tw-duration-250" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-ease-in-out tw-duration-250" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0" beforeLeave={onBeforeLeave} afterLeave={onAfterLeave}>{t1}</TransitionChild>;
    $[1] = onAfterLeave;
    $[2] = onBeforeLeave;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClose) {
    t3 = e => {
      e.stopPropagation();
      onClose();
    };
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="tw-w-6 tw-h-6 tw-flex-shrink-0 tw-text-white" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onClose) {
    t5 = <TransitionChild as={Fragment} enter="tw-ease-in-out tw-duration-250" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-ease-in-out tw-duration-250" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-absolute tw-right-0 -tw-top-16 -tw-ml-8 tw-flex tw-pr-2 tw-pt-4 sm:-tw-ml-10 sm:tw-pr-4"><button type="button" title="Close panel" aria-label="Close panel" className="tw-p-2.5 tw-relative tw-bg-transparent tw-rounded-md focus:tw-outline-none tw-border-none focus:tw-ring-2 focus:tw-ring-white" onClick={onClose}>{t4}</button></div></TransitionChild>;
    $[7] = onClose;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `tw-flex tw-flex-col tw-bg-iron-950 tw-rounded-t-xl tw-overflow-y-auto tw-scroll-py-3 ${noPadding ? "tw-py-0" : "tw-py-6 "}`;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      maxHeight: "calc(100dvh - 10rem)"
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== title) {
    t8 = title && <DialogTitle className="tw-text-base tw-font-semibold tw-text-iron-50">{title}</DialogTitle>;
    $[10] = title;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <div className="tw-px-4 sm:tw-px-6">{t8}</div>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== children || $[15] !== t6 || $[16] !== t9) {
    t10 = <div className={t6} style={t7}>{t9}{children}</div>;
    $[14] = children;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t5) {
    t11 = <div className="tw-absolute tw-inset-0 tw-overflow-hidden" onClick={_temp}><div className="tw-flex tw-justify-center tw-pointer-events-none tw-fixed tw-inset-x-0 tw-bottom-0 tw-max-w-full tw-pt-10"><TransitionChild as={Fragment} enter="tw-transform tw-transition tw-ease-in-out tw-duration-250 sm:tw-duration-350" enterFrom="tw-translate-y-full" enterTo="tw-translate-y-0" leave="tw-transform tw-transition tw-ease-in-out tw-duration-250 sm:tw-duration-350" leaveFrom="tw-translate-y-0" leaveTo="tw-translate-y-full"><DialogPanel className="tw-pointer-events-auto tw-relative tw-w-screen md:tw-max-w-screen-md" onClick={_temp2}>{t5}{t10}</DialogPanel></TransitionChild></div></div>;
    $[18] = t10;
    $[19] = t5;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t3) {
    t12 = <div className="tw-fixed tw-inset-0" onClick={t3}>{t11}</div>;
    $[21] = t11;
    $[22] = t3;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== onClose || $[25] !== t12 || $[26] !== t2) {
    t13 = <Dialog as="div" className="tailwind-scope tw-absolute tw-z-[1010]" onClose={onClose}>{t2}{t12}</Dialog>;
    $[24] = onClose;
    $[25] = t12;
    $[26] = t2;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== isOpen || $[29] !== t13) {
    t14 = <Transition appear={true} show={isOpen} as={Fragment}>{t13}</Transition>;
    $[28] = isOpen;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}
function _temp2(e_1) {
  return e_1.stopPropagation();
}
function _temp(e_0) {
  return e_0.stopPropagation();
}